import {
  CommunicationSubTab,
  NotificationKind,
  NotificationTab
} from "../types";

// Older links (and the bell) still say ?tab=call / ?tab=ai_agent /
// ?tab=message; they all live under Communications now.
const LEGACY_TABS: Partial<Record<string, CommunicationSubTab>> = {
  [NotificationKind.Call]: CommunicationSubTab.Calls,
  [NotificationKind.AiAgent]: CommunicationSubTab.Calls,
  [NotificationKind.Message]: CommunicationSubTab.Messages
};

// The BoomScreen and BoomCRM tabs, see `showsProductNotificationTabs`.
const PRODUCT_TABS: string[] = [
  NotificationTab.Application,
  NotificationTab.Mention,
  NotificationTab.Assigned,
  NotificationTab.Communication
];

export const resolveTabs = (
  tab: string | null,
  sub: string | null,
  {
    showsCalls,
    showsPropertyShield,
    showsPhoneNumbers,
    showsProducts,
    showsProductTabs
  }: {
    showsCalls: boolean;
    showsPropertyShield: boolean;
    showsPhoneNumbers: boolean;
    showsProducts: boolean;
    showsProductTabs: boolean;
  }
): { tab: NotificationTab; sub: CommunicationSubTab } => {
  const legacySub = tab ? LEGACY_TABS[tab] : undefined;
  const requestedTab = legacySub ? NotificationTab.Communication : tab;
  const knownTab = Object.values(NotificationTab).includes(
    requestedTab as NotificationTab
  );
  const hiddenTab =
    (requestedTab === NotificationTab.PropertyShield && !showsPropertyShield) ||
    (requestedTab === NotificationTab.PhoneNumbers && !showsPhoneNumbers) ||
    (requestedTab === NotificationTab.Products && !showsProducts) ||
    (!showsProductTabs && PRODUCT_TABS.includes(requestedTab as string));
  const defaultTab = showsProductTabs
    ? NotificationTab.Mention
    : NotificationTab.RentalVerification;
  const validTab =
    knownTab && !hiddenTab ? (requestedTab as NotificationTab) : defaultTab;
  const requestedSub =
    legacySub ??
    (sub === CommunicationSubTab.Messages
      ? CommunicationSubTab.Messages
      : CommunicationSubTab.Calls);
  // Without Boom calling or the AI Leasing Agent there is no Calls sub-tab.
  const validSub = showsCalls ? requestedSub : CommunicationSubTab.Messages;
  return { tab: validTab, sub: validSub };
};
